import { API } from "aws-amplify"

export const getAllMRs = (date) => {
    return API.get('baseURL', `/ae/meter-readers`)
}